<ng-container>
    <div class="wrapper__form">
        <app-form
            [fields]="formFieldTieneApoderado"
            [withSubmitButton]="false"
            (changedControl)="onChangeTieneApoderado($event)"
            [idEntidad]="entidadId">
        </app-form>
        <div class="row mt-2" *ngIf="formTieneApoderado.get('tieneApoderado')?.value == 1">
            <div class="d-flex flex-row align-items-start">
              <h6 class="mb-0 h6-tipografia-govco" style="color: red;">{{ sfcText['sfc-procon']['cambio-apoderado'] }}</h6>
            </div>
          </div>
        <app-form
            *ngIf="formTieneApoderado.get('tieneApoderado')?.value == 1"
            [title]="sfcText['tramite-sic-comp-desleal']['apoderado']"
            [fields]="formFieldApoderado"
            [withSubmitButton]="false"
            (changeAction)="changeActionApoderado($event)"
            (changedControl)="onChangeApoderado($event)"
            [idEntidad]="entidadId">
        </app-form>
        <div class="d-flex flex-wrap justify-content-end gap-2 mt-md-5 mt-3"
            *ngIf="formTieneApoderado.get('tieneApoderado')?.value == 1">
            <button
                type="submit" class="btn-govco fill-add-govco mt-3"
                [disabled]="formApoderado?.invalid"
                (click)="agregarApoderado()"
                [attr.aria-label]="sfcText['sfc-procon']['guardar-apoderado']">
                {{ sfcText['sfc-procon']['guardar-apoderado'] }}
            </button>
        </div>
        <div *ngIf="formTieneApoderado.get('tieneApoderado')?.value == 1">
            <app-table
            [estiloEncabezado]="'height: auto !important;'"
            *ngIf="dataTableApoderados.length > 0"
            id="tblApoderado"
            [acciones]="actions"
            (eventoAccion)="accionesApoderado($event)"
            [datos]="dataTableApoderados"
            [columnas]="columnsApoderado"
            [paginacion]="false" />
        <br />
            <div class="wrapper__form">
                <div class="col-12 col-xl-12 mb-3">
                <app-cargue-archivos-tramite
                        *ngIf="getFilesPrecargadosByPaso(2).length > 0"
                        [archivosPreCargados]="getFilesPrecargadosByPaso(2)"
                        [paso]="2"
                        [idTipoTramite]="entidadId"
                        [idTramite]="tramiteSfc?.id!"
                        [btnEnviar]="false"
                        [enviar]="enviarDocumentos"
                        [enviarEntidad]="enviar"
                        (archivosObligatoriosPasos)="getFileRequeridos($event)"
                        (guardo)="subirArchivo($event)"
                        (archivosCargados)="validarArchivosCargados($event, 2)">
                </app-cargue-archivos-tramite>
                <app-cargue-archivos-tramite
                        *ngIf="getFilesPrecargadosByPaso(2).length == 0"
                        [archivosPreCargados]="getFilesPrecargadosByPaso(2)"
                        [paso]="2"
                        [idTipoTramite]="entidadId"
                        [idTramite]="tramiteSfc?.id!"
                        [btnEnviar]="false"
                        [enviar]="enviarDocumentos"
                        [enviarEntidad]="enviar"
                        (archivosObligatoriosPasos)="getFileRequeridos($event)"
                        (guardo)="subirArchivo($event)"
                        (archivosCargados)="validarArchivosCargados($event, 2)">
                </app-cargue-archivos-tramite>
                    <div class="mt-3 text-muted small d-flex align-items-center">
                        <i class="bi bi-info-circle me-2"></i>
                        {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
        <div class="d-flex flex-column flex-md-row gap-2">
            <button
                type="submit"
                class="btn-govco fill-before-btn-govco w-auto"
                onClick="nextItemAdvanceLineIHorizonalBack(event)"
                (click)="atras()"
                [attr.aria-label]="sfcText['botones-envio']['atras']">
                {{ sfcText['botones-envio']['atras'] }}
                </button>
            <button
                type="button"
                class="btn-govco fill-btn-govco w-auto"
                (click)="seguirConDemandado($event, true)"
                [attr.aria-label]="sfcText['botones-envio']['guardar-sin-enviar']">
                {{ sfcText['botones-envio']['guardar-sin-enviar'] }}
            </button>
            <button
                type="submit"
                class="btn-govco fill-next-btn-govco btn-form w-auto"
                (click)="seguirConDemandado($event, false)"
                [attr.aria-label]="sfcText['siguiente']">
                {{ sfcText['siguiente'] }}
            </button>
        </div>
    </div>
</ng-container>
